declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: any[]) => void;
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

const YM_ID = 107024495;
const GA4_ID = 'G-MVM9XQHS0P';

export function ymGoal(goalName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.ym) {
    window.ym(YM_ID, 'reachGoal', goalName, params);
  }
}

export function gaEvent(eventName: string, params?: Record<string, any>) {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
}

export function trackRegister() {
  ymGoal('register');
  gaEvent('sign_up', { method: 'email' });
}

/**
 * Подтверждение email кодом (страница /verify-email).
 *
 * Идентификатор события `registration_complete` — исторический и оставлен как
 * есть: на него настроена цель Метрики id 548833970, переименование обнулит
 * накопленную статистику. По смыслу это НЕ регистрация (та — `register`),
 * поэтому в воронку привлечения специалистов цель не включена: иначе двойной
 * счёт одного и того же пользователя.
 */
export function trackEmailVerified() {
  ymGoal('registration_complete');
  gaEvent('registration_complete');
}

export function trackLogin() {
  ymGoal('login');
  gaEvent('login', { method: 'email' });
}

export function trackBookingCreated(params?: { serviceTitle?: string; price?: number }) {
  ymGoal('booking_created', params);
  gaEvent('purchase', {
    currency: 'RUB',
    value: params?.price ?? 0,
    items: [{ item_name: params?.serviceTitle ?? 'Услуга' }],
  });
}

export function trackResponseSent() {
  ymGoal('response_sent');
  gaEvent('response_sent');
}

export function trackRequestCreated() {
  ymGoal('request_created');
  gaEvent('request_created');
}

export function trackSpecialistProfileCreated() {
  ymGoal('specialist_profile_created');
  gaEvent('specialist_profile_created');
}

// Воронка привлечения специалистов из Яндекс Директа (ТЗ DIRECT-ANALYTICS,
// первая ступень добавлена в ТЗ LP-GOALS):
// lp_cta_click → spec_intent → register → specialist_profile_created →
// service_created → schedule_created. Цели «регистрация» и «профиль создан»
// уже существовали под именами register / specialist_profile_created — по
// правилам ТЗ имена сохранены, переименования нет.

/** Клик по CTA на лендинге /for-business — верх рекламной воронки. */
export function trackLpCtaClick(label: string) {
  ymGoal('lp_cta_click', { label });
  gaEvent('lp_cta_click', { label });
}

/** Интерес к роли специалиста: 30 сек на /become-specialist, один раз за сессию. */
export function trackSpecIntent() {
  ymGoal('spec_intent');
  gaEvent('spec_intent');
}

export function trackServiceCreated() {
  ymGoal('service_created');
  gaEvent('service_created');
}

export function trackScheduleCreated() {
  ymGoal('schedule_created');
  gaEvent('schedule_created');
}

export function trackSpecialistView(specialistId: string) {
  ymGoal('specialist_view', { specialistId });
  gaEvent('view_item', { item_id: specialistId, item_category: 'specialist' });
}

export function trackAddToFavorites() {
  ymGoal('add_to_favorites');
  gaEvent('add_to_wishlist');
}

export function trackReviewSubmitted(rating: number) {
  ymGoal('review_submitted', { rating });
  gaEvent('review_submitted', { rating });
}
